import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { getLocale, isRtl } from './locales';

const RTL_LINK_ID = 'saf3ai-bootstrap-rtl';
// Copied from bootstrap/dist/css at setup so it can be toggled as a real <link>
// (a webpack CSS import cannot be un-applied when switching back to LTR).
// TODO(i18n): re-copy public/vendor/bootstrap.rtl.min.css whenever the bootstrap
//   dependency is upgraded, or the RTL sheet silently drifts from bootstrap.min.css.
//   Owner: frontend. Verify: diff the version banner at the top of both files.
const RTL_HREF = '/vendor/bootstrap.rtl.min.css';

function applyDirection(code) {
  const html = document.documentElement;
  const rtl = isRtl(code);

  html.setAttribute('lang', code);
  html.setAttribute('dir', rtl ? 'rtl' : 'ltr');
  // Lets app CSS target [dir="rtl"] without reading i18next state.
  html.classList.toggle('rtl-mode', rtl);

  let link = document.getElementById(RTL_LINK_ID);
  if (rtl) {
    if (!link) {
      link = document.createElement('link');
      link.id = RTL_LINK_ID;
      link.rel = 'stylesheet';
      link.href = RTL_HREF;
      // Appended last so it overrides the LTR bootstrap bundle imported in
      // vendorSetup.js — CSS order, not specificity, is what makes this work.
      document.head.appendChild(link);
    }
    link.disabled = false;
  } else if (link) {
    link.disabled = true;
  }
}

/**
 * Keeps the document's lang/dir attributes and the RTL stylesheet in sync with
 * the active locale. Renders nothing itself.
 */
export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const code = i18n.language;

  useEffect(() => {
    applyDirection(code);
    document.title = document.title || getLocale(code).label;
  }, [code]);

  return children;
};

export default LanguageProvider;
